<template>
  <div class="h-full overflow-hidden">
    <div class="flex flex-wrap mb-10px mr-10px">
      <el-input
        size="small"
        class="mr-10px !w-50 mb-10px"
        placeholder="预案名称"
        maxlength="50"
        v-model="searchData.emergencyPlanName"
        clearable
      ></el-input>
      <el-date-picker
        v-model="searchData.datePickerValue"
        class="mr-10px"
        format="yyyy-MM-dd HH:mm:ss"
        size="small"
        type="datetimerange"
        :clearable="true"
        start-placeholder="预案演练开始时间"
        end-placeholder="预案演练结束时间"
        value-format="yyyy-MM-dd HH:mm:ss"
      >
      </el-date-picker>
      <el-button size="small" type="primary" @click="searchList()">搜索</el-button>
      <el-button size="small" @click="resetSearch()">重置</el-button>
      <el-button size="small" type="primary" @click="addSituationSolutionDialog">新增</el-button>
    </div>
    <el-table
      :data="situationSolutionData"
      border
      stripe
      class="mt-20px"
      :height="tableHeight"
      v-loading="loading"
    >
      <el-table-column type="index" label="序号" width="60" show-overflow-tooltip></el-table-column>
      <el-table-column
        label="预案名称"
        prop="emergencyPlanName"
        show-overflow-tooltip
      ></el-table-column>
      <el-table-column label="预案编制时间" prop="publishedTime" show-overflow-tooltip>
        <template slot-scope="scope">
          {{ dayjs(scope.row.publishedTime).format('YYYY-MM-DD HH:mm:ss') }}
        </template>
      </el-table-column>
      <el-table-column label="预案演练时间" prop="exerciseTime" show-overflow-tooltip
        ><template slot-scope="scope">
          {{ dayjs(scope.row.exerciseTime).format('YYYY-MM-DD HH:mm:ss') }}
        </template></el-table-column
      >
      <el-table-column
        label="预案演练评估"
        prop="evaluation"
        show-overflow-tooltip
      ></el-table-column>
      <el-table-column label="备注" prop="remark" show-overflow-tooltip></el-table-column>
      <el-table-column label="操作" fixed="right" width="280">
        <template slot-scope="scope">
          <el-button size="mini" @click="handleEvent('read', scope.row)">查看</el-button>
          <el-button size="mini" type="primary" @click="handleEvent('edit', scope.row)"
            >编辑</el-button
          >
          <el-button size="mini" type="danger" @click="handleEvent('delete', scope.row)"
            >删除</el-button
          >
        </template>
      </el-table-column>
    </el-table>
    <el-pagination
      background
      @size-change="situationSolutionTableSizeChange"
      @current-change="situationSolutionableCurrentChange"
      :current-page.sync="situationSolutionPageConfig.SkipCount"
      :page-size.sync="situationSolutionPageConfig.MaxResultCount"
      layout="total, sizes, prev, pager, next, jumper"
      :page-sizes="[15, 30, 45, 60, 75, 90]"
      :total="situationSolutionPageConfig.total"
      class="float-right mt-20px ml-20px clear-both"
    ></el-pagination>
    <AddSituationSolution
      v-if="situationSolutionVisible"
      v-model="situationSolutionVisible"
      :contractorId="contractorId"
      :saveRow="saveRow"
      :pageConfigType="pageConfigType"
    />
  </div>
</template>
<script>
import dayjs from 'dayjs'
import { ContractorApi } from '@wiz-api/contractor-management'
import AddSituationSolution from './addSituationSolution'

const contractorApi = new ContractorApi()

export default {
  components: {
    AddSituationSolution,
  },
  data() {
    return {
      pageConfigType: 'create',
      loading: false,
      searchData: {
        datePickerValue: [],
      },
      saveRow: {},
      situationSolutionVisible: false,
      situationSolutionData: [],
      situationSolutionPageConfig: {
        SkipCount: 1,
        MaxResultCount: 15,
        total: 0,
      },
    }
  },
  props: {
    contractorId: {
      type: String,
      default: '',
    },
  },
  computed: {
    tableHeight() {
      return 'calc(100% - 117px)'
    },
  },
  watch: {
    situationSolutionVisible: {
      handler(val) {
        if (!val) {
          this.saveRow = {}
          this.resetSearch()
        }
      },
    },
  },
  created() {
    this.getData()
  },
  methods: {
    handleEvent(type, row) {
      if (type === 'edit' || type === 'read') {
        this.situationSolutionVisible = true
        this.pageConfigType = type
        this.saveRow = JSON.parse(JSON.stringify(row))
      } else {
        this.$confirm('请确认是否删除？', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning',
        })
          .then(async () => {
            const [err, res] = await contractorApi.deleteOnSiteDisposalPlan(
              this.contractorId,
              row.id
            )
            if (!err) {
              this.$message.success('删除成功')
              this.getData()
            }
          })
          .catch(() => {})
      }
    },
    addSituationSolutionDialog() {
      this.situationSolutionVisible = true
      this.pageConfigType = 'create'
    },
    // 奖励考核信息页码改变
    situationSolutionTableSizeChange(MaxResultCount) {
      this.rewardsAndAssessment.MaxResultCount = MaxResultCount
      this.getData()
    },
    // 奖励考核信息页数改变
    situationSolutionableCurrentChange(SkipCount) {
      this.rewardsAndAssessmentPageConfig.SkipCount = SkipCount
      this.getData()
    },
    searchList() {
      this.situationSolutionPageConfig.SkipCount = 1
      this.getData()
    },
    resetSearch() {
      this.searchData = {
        datePickerValue: [],
      }
      this.situationSolutionPageConfig.SkipCount = 1
      this.getData()
    },
    async getData() {
      this.loading = true
      this.searchData.exerciseTimeBegin
      const data = {
        exerciseTimeBegin: this.searchData.datePickerValue.length
          ? dayjs(this.searchData.datePickerValue[0]).format('YYYY-MM-DD HH:mm:ss')
          : '',
        exerciseTimeEnd: this.searchData.datePickerValue.length
          ? dayjs(this.searchData.datePickerValue[1]).format('YYYY-MM-DD HH:mm:ss')
          : '',
        emergencyPlanName: this.searchData.emergencyPlanName,
        maxResultCount: this.situationSolutionPageConfig.MaxResultCount, // 每页多少条
        skipCount:
          (this.situationSolutionPageConfig.SkipCount - 1) *
          this.situationSolutionPageConfig.MaxResultCount, // 跳过多少条
      }
      this.loading = true
      const [err, res] = await contractorApi.getOnSiteDisposalPlansByPage(this.contractorId, data)
      if (!err) {
        this.situationSolutionData = res.items
        this.situationSolutionPageConfig.total = res.totalCount
      }
      this.loading = false
    },
  },
}
</script>
